import React, { FC, MouseEvent, useEffect, useRef, useState } from 'react';
import './video-slide-content.sass';
import { IPost } from '../../../../../../../shared/types/Post';
import { ISlidePostConfig } from '../../../horizontal-slider/horizontal-slider-layout';
import SlideBox from '../../../horizontal-slider/components/slide-box/slide-box';
import SlideImage from '../../../horizontal-slider/components/slide-image/slide-image';
import CallToActionGroup from '../../../../../../../shared/components/call-to-action-group/call-to-action-group';
import ProductIcon from '../../../../../../../shared/components/ecommerce/product-icon/product-icon';

export interface ISliderContentProps {
  post: IPost;
  config: ISlidePostConfig;
  onClick: (post: IPost) => void;
  onCtaClick: (post: IPost) => void;
  activeCTAIndex: number;
  prevCta: (event: MouseEvent<Element>) => void;
  nextCta: (event: MouseEvent<Element>) => void;
  tabIndex: number;
  shouldDisplayCta?: boolean;
  shouldOpenPopup?: boolean;
  isProduct?: boolean;
}

export const VideoSlideContent: FC<ISliderContentProps> = ({
  post,
  config,
  onClick,
  onCtaClick,
  activeCTAIndex,
  prevCta,
  nextCta,
  tabIndex,
  shouldDisplayCta = true,
  shouldOpenPopup,
  isProduct,
}) => {
  const [mouseOver, setMouseOver] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && mouseOver) {
      videoRef.current.play();
    } else if (videoRef.current) {
      videoRef.current.pause();
    }
  }, [mouseOver]);

  const onMouseOver = () => setMouseOver(true);
  const onContentClick = () => onClick && onClick(post);
  const onMouseOut = () => setMouseOver(false);
  const {
    attributes: { image_url: imageUrl, video_url: videoUrl },
  } = post;

  return (
    <div
      className="video-slide"
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={() => shouldOpenPopup && onContentClick()}
    >
      <SlideBox isVerticalOrientation={false}>
        <video
          ref={videoRef}
          data-testid={'video-player'}
          width="100%"
          height="100%"
          preload="metadata"
          playsInline={true}
          loop={true}
          poster={imageUrl ?? ''}
          muted
          controls={false}
        >
          <source type="video/mp4" src={videoUrl ?? ''} />
        </video>
        {!mouseOver ? <div className="video-slide__play-button" /> : null}
        {shouldDisplayCta && (
          <div className="video-slide__cta-wrapper video-slide__cta-wrapper--with-image">
            <CallToActionGroup
              ctaConfig={config.ctaConfig}
              post={post}
              onCtaClick={onCtaClick}
              cta={[post.cta[activeCTAIndex]]}
              prevCta={prevCta}
              nextCta={nextCta}
              isInSliderTheme={true}
              tabIndex={tabIndex}
            />
          </div>
        )}
        {isProduct && <ProductIcon />}
      </SlideBox>
    </div>
  );
};
